/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var basename = require( 'pkg-basename' );
var kind = require( 'pkg-kind' );


// MAIN //

/**
* Generates a document title for a provided package name.
*
* @private
* @param {string} pkg - package name (e.g., `math/base/special/sin`)
* @returns {string} document title
*/
function pkg2title( pkg ) {
	var t = kind( pkg, '.' ); // try determining the "kind" first, as top-level namespaces don't have a "kind", and we want to avoid an empty slot (e.g., 'array | | stdlib')
	if ( t ) {
		t = basename( pkg ) + ' | ' + t;
	} else {
		t = basename( pkg );
	}
	return t;
}


// EXPORTS //

module.exports = pkg2title;
